import { render, staticRenderFns } from "./StockEditor.vue?vue&type=template&id=5ad20d88&"
import script from "./StockEditor.vue?vue&type=script&lang=js&"
export * from "./StockEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad20d88')) {
      api.createRecord('5ad20d88', component.options)
    } else {
      api.reload('5ad20d88', component.options)
    }
    module.hot.accept("./StockEditor.vue?vue&type=template&id=5ad20d88&", function () {
      api.rerender('5ad20d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/StockEditor.vue"
export default component.exports